import redirectInterceptor from "@/interceptors/redirect_interceptor";

export class NotificationService {
  constructor(notificationDataMapper, baseUrl) {
    this.notificationDataMapper = notificationDataMapper;
    this.baseUrl = baseUrl;
  }

  async getMany(accessToken) {
    try {
      const response = await redirectInterceptor.get(`${this.baseUrl}/notifications`, {
        headers: {
          Authorization: `${accessToken}`
        }
      });
      const result = response.data.map((datum) => this.notificationDataMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateMany(accessToken, notifications) {
    const requestParams = {
      method: "PUT",
      url: `${this.baseUrl}/notifications`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        Authorization: `${accessToken}`
      },
      data: notifications
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      const result = response.data.map((datum) => this.notificationDataMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }
}
